import "./TextCTA.scss";
import PropTypes from "prop-types";
import { GSAPAnimation } from "components/GSAP";

export const TextCTA = ({ component, lang, country }) => {
  const {
    text,
    position,
    size,
    animation,
    fullHeight,
    backgroundColor,
    marginBottom,
  } = component.fields;
  const hasBg = backgroundColor.staticValue !== "transparent";
  const linkCta = component.fields.cta;

  return (
    <>
      <div
        className={`text-cta ${fullHeight.staticValue ? "full-height" : ""} ${
          hasBg ? "has-bg" : marginBottom.staticValue[0]
        }`}
        style={{ backgroundColor: backgroundColor.staticValue }}
      >
        <div
          className={`text-cta__inner ${size.staticValue[0]}`}
          style={{
            textAlign: position.staticValue[0],
            alignItems:
              position.staticValue[0] === "left" ? "flex-start" : "center",
          }}
        >
          <GSAPAnimation
            onScreenAnimation={
              animation.staticValue[0] === "scroll_trigger"
                ? "scrollText"
                : "easeIn"
            }
            className="text-cta__animation"
          >
            <div
              className="text-cta__content"
              style={{ textAlign: position.staticValue[0] }}
              dangerouslySetInnerHTML={{ __html: text.staticValue }}
            />
          </GSAPAnimation>
          {linkCta?.text?.staticValue && (
            <GSAPAnimation onScreenAnimation="fadeUp">
              <a
                href={linkCta.link.staticValue}
                target={linkCta.newTab.staticValue ? "_blank" : null}
                rel={linkCta.newTab.staticValue ? "noopener noreferrer" : null}
                className="text-cta__action"
              >
                {linkCta.text.staticValue}
              </a>
            </GSAPAnimation>
          )}
        </div>
      </div>
    </>
  );
};

TextCTA.propTypes = {
  lang: PropTypes.string.isRequired,
  country: PropTypes.string,
  path: PropTypes.arrayOf(PropTypes.string).isRequired,
  component: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    controlId: PropTypes.arrayOf(PropTypes.string).isRequired,
    fields: PropTypes.shape({
      text: PropTypes.shape({
        staticValue: PropTypes.string.isRequired,
      }).isRequired,
      isBoardDirectors: PropTypes.shape({
        staticValue: PropTypes.bool.isRequired,
      }),
      cta: PropTypes.shape({
        text: PropTypes.shape({
          staticValue: PropTypes.string.isRequired,
        }).isRequired,
        link: PropTypes.shape({
          staticValue: PropTypes.string.isRequired,
        }).isRequired,
        newTab: PropTypes.shape({
          staticValue: PropTypes.bool.isRequired,
        }).isRequired,
      }),
      position: PropTypes.shape({
        staticValue: PropTypes.arrayOf(
          PropTypes.oneOf(["left", "center"]).isRequired
        ),
      }).isRequired,
      size: PropTypes.shape({
        staticValue: PropTypes.arrayOf(
          PropTypes.oneOf(["small", "medium", "large"]).isRequired
        ),
      }),
      animation: PropTypes.shape({
        staticValue: PropTypes.arrayOf(
          PropTypes.oneOf(["ease_in", "scroll_trigger"]).isRequired
        ),
      }),
      fullHeight: PropTypes.shape({
        staticValue: PropTypes.bool.isRequired,
      }),
      backgroundColor: PropTypes.shape({
        staticValue: PropTypes.string.isRequired,
      }),
      marginBottom: PropTypes.shape({
        staticValue: PropTypes.oneOf([
          "margin__bottom__0",
          "margin__bottom__80",
          "margin__bottom__160",
          "margin__bottom__240",
        ]).isRequired,
      }),
    }).isRequired,
  }).isRequired,
};
